/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Force_End_DescInputs */

const vi_trip_force_end_desc = /** @type {(inputs: Trip_Force_End_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dùng khi tài xế quên bấm kết thúc chuyến, hoặc không còn liên lạc được để tự xử lý đơn. Chọn kết quả cho từng đơn còn đang giao (như tài xế tự bấm); có thể ghi thêm lý do để lưu vết.`)
};

/**

* @param {Trip_Force_End_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_force_end_desc = /** @type {((inputs?: Trip_Force_End_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Force_End_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_force_end_desc(inputs)
});